import axios from "axios";
import API from "../helpers/api";
let searchData = {
  ShipName: "",
  ImoNo: "",
  Flag: "",
  Class: "",
  Grt: "",
  status:"Inactive",
  DeadWeight: "",
  PageNumber: 1,
  PageSize: 20,
};
export const getInactiveShipList = (item) => {
  let url = `${API.getShipList}?ShipName=${item.ShipName}&ImoNo=${item.ImoNo}&Flag=${item.Flag}&Class=${item.Class}&status=${item.status}&Grt=${item.Grt}&DeadWeight=${item.DeadWeight}&PageNumber=${item.PageNumber}&PageSize=${item.PageSize}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getInactiveShipListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getgetInactiveShipListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipManagementDetails = (id) => {
  let url = `${API.getShipDetail}?shipId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getInactiveShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipManagementDetailFailure",
          error: "ERROR",
        });
      });
  };
};

export const getShipStatusList = () => {
  let url = `${API.getShipStatus}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipStatusListSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getShipStatusListFailure",
          error: "ERROR",
        });
      });
  };
};
export const getShipEquipmentDetails = (id) => {
  let url = `${API.getShipEquipment}?shipId=${id}`;
  return (dispatch) => {
    axios
      .get(url)
      .then((response) => {
        dispatch({
          type: "getShipEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "getClientShipDetailFailure",
          error: "ERROR",
        });
      });
  };
};
export const postShipDetails = (data) => {
  let currentUser = JSON.parse(localStorage.getItem("currentUser"));
  let url = `${API.getShipDetail}`;
  return (dispatch) => {
    axios
      .put(url, data, {
        headers: {
          key: currentUser.accessToken,
        },
      })
      .then((response) => {
        dispatch({
          type: "PostShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "PostShipDetailFailure",
          data: "error",
        });
      });
  };
};
export const postEquipmentDetails = (data, searchData) => {
  let url = `${API.postShipEquipment}`;

  return (dispatch) => {
    axios
      .post(url, data)
      .then((response) => {
        if (response.data) {
          this.props.history.push("/Home/ShipManagement");
          dispatch(getInactiveShipList(searchData));
          dispatch({
            type: "PostEquipmentDetailSuccess",
            data: response.data,
          });
        }
      })
      .catch((error) => {
        dispatch({
          type: "PostEquipmentDetailFailure",
          data: "error",
        });
      });
  };
};
export const UpdateShipDetails = (data) => {
  let url = `${API.getShipDetail}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "UpdateShipDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UpdateShipDetailFailure",
          data: "error",
        });
      });
  };
};
export const UpdateEquipmentDetails = (data) => {
  let url = `${API.postShipEquipment}`;
  return (dispatch) => {
    axios
      .put(url, data)
      .then((response) => {
        dispatch({
          type: "UpdateEquipmentDetailSuccess",
          data: response.data,
        });
      })
      .catch((error) => {
        dispatch({
          type: "UpdateEquipmentDetailFailure",
          data: "error",
        });
      });
  };
};
